import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { Guid, Visibility, createTypedField, DotNetType } from 'tessa/platform';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { TaskViewModel } from 'tessa/ui/cards/tasks';
import { CardRequest, CardService } from 'tessa/cards/service';
import { CdRequestTypes } from 'src/cdScripts/Helpers/CdRequestTypes';

export class CdHideControlUIExtension extends CardUIExtension {
    public initialized(context: ICardUIExtensionContext) {
        if (context.model == null || context.model.card == null) {
          return;
        }
        if (!Guid.equals(context.model.card.typeId, CdCardTypes.TechnicalDocumentationTypeID)) {
            return;
        }
        let tasks = context.model.tryGetTasks();
        if (tasks == null || tasks.length < 1) return;
        for (let task of tasks) {
            this.HideControl(task, context);
            task.workspaceChanged.add(e => this.HideControl(e.task, context));
        }
    }
    private async HideControl(taskModel: TaskViewModel, context: ICardUIExtensionContext) {
        const block = taskModel.taskModel.blocks.get('Block2');
        if (block == null)
            return;

        const control = block!.controls.find(x => x.name === 'WithRsoBeforeFr');

        if (control == null)
            return;

        let task = context.card.tasks.find(x => x.rowId === taskModel.taskModel.cardTask!.tryGetCard()!.id);

        const request = new CardRequest();
        request.requestType = CdRequestTypes.GetParentRoleID;
        request.info["CardID"] = createTypedField(context.model.card.id, DotNetType.Guid);
        request.info["RoleID"] = createTypedField(task!.roleId, DotNetType.Guid);

        const response = await CardService.instance.request(request);

        if (!response.validationResult.isSuccessful)
            return;
            
        if (response.info.IsNewRenovationAgreementProcess && response.info.IsNewRenovationAgreementProcess.$value
            && response.info.ParentRoleId.$value === "365588ca-1aa4-4fc1-b991-99d4de213a18")
            control.controlVisibility = Visibility.Visible;
    }
}